module.exports = __webpack_public_path__ + "img/g1.978fd0d0.jpg";